/** Explicit route vocabulary: never export identifiers, queries or fragments. */
export function telemetryRoute(input: string): string {
  const path = input.split(/[?#]/, 1)[0] ?? "";
  const fixed = ["/", "/this-week", "/people", "/roles", "/requests", "/requests/new", "/it/runs", "/it/reviews", "/it/lease",
    "/api/access/roles", "/api/me", "/api/people", "/api/requests", "/api/requests/schedule", "/api/runs", "/api/tasks", "/api/roles", "/api/lease"];
  if (fixed.includes(path)) return path;
  for (const [pattern, route] of [
    [/^\/api\/people\/[^/]+\/access-policy$/, "/api/people/{upn}/access-policy"],
    [/^\/api\/people\/[^/]+\/tasks$/, "/api/people/{upn}/tasks"],
    [/^\/api\/people\/[^/]+$/, "/api/people/{upn}"],
    [/^\/api\/requests\/[^/]+\/approval$/, "/api/requests/{request_id}/approval"],
    [/^\/api\/requests\/[^/]+\/license-availability$/, "/api/requests/{request_id}/license-availability"],
    [/^\/api\/requests\/[^/]+$/, "/api/requests/{request_id}"],
    [/^\/api\/runs\/[^/]+$/, "/api/runs/{run_id}"],
    [/^\/people\/[^/]+$/, "/people/{upn}"],
    [/^\/requests\/[^/]+$/, "/requests/{request_id}"],
    [/^\/it\/runs\/[^/]+$/, "/it/runs/{run_id}"],
  ] as const) {
    if (pattern.test(path)) return route;
  }
  return "/unknown";
}
